import React, { useEffect, useState } from "react";
import { parseString } from "xml2js";
import "./HomePage.css";
import Tick from "../../assets/icons/check-mark.png";
import Qrcode from "../../assets/images/qrcode.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import EGazetteLogo from "../../assets/images/e-gazette.png";
import LawLibraryLogo from "../../assets/images/law-library.png";
import CaseLawLogo from "../../assets/images/case-law.png";
import SHELogo from "../../assets/images/safety-health-environment.png";
import ResourceCenterLogo from "../../assets/images/resource-centre.png";
import IndexLogo from "../../assets/images/index.png";
import LatinLogo from "../../assets/images/latin-dictionaries.png";
import TermLogo from "../../assets/images/terms.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaRegCheckCircle,
  FaYoutube,
} from "react-icons/fa";
import { IoIosArrowDropright } from "react-icons/io";
import Header from "./Header";
import api from "../../services/baseUrl";
import FeedbackDialog from "../../components/FeedbackDialog";

export default function HomePage() {
  const navigate = useNavigate();
  const [firstSliderActive, setFirstSliderActive] = useState(0);
  const [secondSliderActive, setSecondSliderActive] = useState(0);
  const [numOfUsers, setNumOfUsers] = useState(3000);
  const [numOfLegislation, setNumOfLegislation] = useState(3000);
  const [numOfGazette, setNumOfGazette] = useState(50000);
  const [articles, setArticles] = useState([]);
  const [latestGazetteEntries, setLatestGazetteEntries] = useState([]);
  const [latestCaseLawEntries, setLatestCaseLawEntries] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.substring(1);

      const section = document.getElementById(id);
      if (section) {
        if (section) {
          const yOffset = 300;
          const y =
            section.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    }
  }, []);

  useEffect(() => {
    const getNumOfUser = async () => {
      try {
        const response = await api.post(
          "/totalUsers",

          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        setNumOfUsers(response.data);
      } catch (error) {}
    };

    const getNumOfLegislation = async () => {
      try {
        const response = await api.get("/totalLlDocuments");
        setNumOfLegislation(response.data);
      } catch (error) {}
    };

    const getNumOfGazette = async () => {
      try {
        const response = await api.post(
          "/totalEgDocuments",

          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        setNumOfGazette(response.data);
      } catch (error) {}
    };

    const fetchRSS = async () => {
      try {
        // Make request to Spring Boot backend to fetch RSS
        const response = await api.get("/fetch-rss");
        parseString(response.data, { mergeAttrs: true }, (err, result) => {
          if (err) {
            console.error("Error parsing RSS:", err);
          } else {
            setArticles(result.rss.channel[0].item.slice(0, 10)); // Get first 5 items
          }
        });
      } catch (error) {
        console.error("Error fetching RSS feed:", error);
      }
    };

    const getLatestGazetteEntries = async () => {
      try {
        const [
          response301,
          response303,
          response304,
          response305,
          responseCaseLaw,
        ] = await Promise.all([
          api.get("/latestDocuments301"),
          api.get("/latestDocuments303"),
          api.get("/latestDocuments304"),
          api.get("/latestDocuments305"),
          api.get("latestDocumentsCaseLaw"),
        ]);

        const latestGazetteEntriesPromise = [
          ...response301.data.slice(0, 2),
          ...response303.data.slice(0, 2),
          ...response304.data.slice(0, 2),
          ...response305.data.slice(0, 2),
        ];

        setLatestGazetteEntries(latestGazetteEntriesPromise);

        setLatestCaseLawEntries(responseCaseLaw.data.slice(0, 2));
      } catch (error) {
        console.error("Error fetching latest entries:", error);
      }
    };
    fetchRSS();
    getNumOfGazette();
    getNumOfLegislation();
    getNumOfUser();
    getLatestGazetteEntries();
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    width: "10px",
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (oldIndex, newIndex) => setFirstSliderActive(newIndex),
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          background: i === firstSliderActive ? "#0078ff" : "lightgray",
          marginTop: "10px",
          marginBottom: "20px",
        }}
      ></div>
    ),
  };

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    width: "10px",
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (oldIndex, newIndex) => setSecondSliderActive(newIndex),
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          background: i === secondSliderActive ? "#0078ff" : "lightgray",
          marginTop: "10px",
          marginBottom: "20px",
        }}
      ></div>
    ),
  };
  const handleLogin = () => {
    navigate("/login");
  };

  const handleDashboard = () => {
    navigate("/dashboard");
  };

  const formatNumber = (number) => {
    return number.toLocaleString("en-US");
  };

  const lawnetFeatures = [
    {
      title: "e-Gazette",
      content:
        "An online platform offering official government documents, including federal and state gazettes, amending Acts and legal notices in digital format. The e-Gazette enables legal professionals, government agencies, and the public to easily search and access these documents anytime, anywhere.",
      image: EGazetteLogo,
    },
    {
      title: "Law Library",
      content:
        "Our Law Library offers a comprehensive collection of up-to-date Malaysian legislation, including original and updated Principal Acts, Subsidiary Legislation, Ordinances, Court Rules, and State Enactments, including Syariah legislation, from 2001 onwards. In addition, Lawnet 3.0 provides access to Court Forms and Cause Papers for users’ easy reference. As the official publisher for the Attorney General’s Chambers, we ensure subscribers receive the latest and most updated laws.",
      image: LawLibraryLogo,
    },
    {
      title: "Case Law",
      content:
        "Starting in 2025, we provide access to both reported and unreported grounds of judgments from the Malaysian Judiciary, including decisions from the Federal Court, Court of Appeal, High Court, and subordinate courts. We also publish decisions from the Syariah courts and tribunals. The database will continue to expand to include past landmark and legacy cases.",
      image: CaseLawLogo,
    },
    {
      title: "Safety, Health & Environment",
      content:
        "We provide a collection of legal documents pertaining to Safety, Health, and Environment (SHE) laws, empowering organisations to uphold regulatory compliance and foster a secure, sustainable work environment.",
      image: SHELogo,
    },
    {
      title: "Resource Centre",
      content:
        "We provide direct links to the Parliament Hansard, Commissioners for Oaths, courts locations and Practice Directions.",
      image: ResourceCenterLogo,
    },
    {
      title: "Index",
      content:
        "Users can easily view indexed e-Gazettes, with detailed listings organised by their respective publication dates for quick reference. This feature will continue to be developed to include indexed subject matters of reported case law.",
      image: IndexLogo,
    },
    {
      title: "Latin Dictionaries",
      content:
        "Our database is the first to feature comprehensive and extensive Latin Dictionaries, predating Google, offering subscribers easy access without the need for individual online searches.",
      image: LatinLogo,
    },
    {
      title: "Terms",
      content:
        "To support our diverse subscribers, including Malaysian courts, legal practitioners and educational institutions, we provide comprehensive translations of legal terms between English and Bahasa Malaysia, addressing the challenges they experience in their daily work.",
      image: TermLogo,
    },
  ];

  const combinedData = [
    ...latestGazetteEntries.map((item) => ({ type: "gazette", data: item })),
    ...latestCaseLawEntries.map((item) => ({ type: "caseLaw", data: item })),
  ];

  const handleSocial = (url) => {
    if (!url) {
      console.error("No URL provided");
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goToPrivacyPolicy = () => {
    navigate("/privacy-policy");
  };
  return (
    <div>
      <Header handleLogin={handleLogin} handleDashboard={handleDashboard} />

      <div className="homepage-background" id="home">
        <div className="homepage-title-container">
          <h1>Malaysian Laws</h1>
          <h1>
            at your <span>fingertips</span>
          </h1>
          <p>
            Access to the Government Gazettes and General Notices, and get the latest Acts, Rules, Codes and Case Law Reports for your daily legal reference.
          </p>
          <div className="homepage-buttons">
            <button
              className="homepage-subscribe-button"
              onClick={() => {
                navigate("/register");
              }}
            >
              <img src={Tick} alt="" />
              SUBSCRIBE NOW
            </button>
            {/* <img
              className="homepage-new-image"
              style={{ scale: "0.85" }}
              src={ComingSoon}
              alt=""
              onClick={() => {
                navigate("/eWarta/login");
              }}
            /> */}
            <button
              className="homepage-new-button"
              onClick={() => {
                navigate("/eWarta/login");
              }}
            >
              <img src={Tick} alt="" />
              NEW! GAZETTE ON DEMAND
            </button>
          </div>
        </div>
        <div className="homepage-qrcode">
          <img src={Qrcode} width={"60%"} alt="" />
        </div>
      </div>
      <div className="homepage-statistic-container">
        <div className="homepage-statistic">
          <p>Up to</p>
          <p>{formatNumber(numOfUsers)}+</p>
          <p>Users</p>
        </div>
        <div className="homepage-statistic">
          <p>More than</p>
          <p>{formatNumber(numOfLegislation)}</p>
          <p>Legislations</p>
        </div>
        <div className="homepage-statistic">
          <p>More than</p>
          <p>{formatNumber(numOfGazette)}</p>
          <p>E-Gazettes</p>
        </div>
      </div>
      <div className="homepage-latest-entries">
        <p>Latest&nbsp;entries</p>
        <p>
          Latest Acts, Subsidiary Legislation, e-Gazettes, and Case Law available in Lawnet’s database.
        </p>
      </div>
      <div className="homepage-slider">
        <Slider {...settings}>
          {combinedData.map((item, index) => (
            <div key={index} className="homepage-articles-items">
              {item.type === "gazette" && item.data.egDocumentDto ? (
                // Render Gazette Entry UI
                <div className="articles-text">
                  <h3>{item.data.egDocumentDto.actNo}</h3>

                  {item.data.egDocumentDto.actTitleBI ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: item.data.egDocumentDto.actTitleBI,
                      }}
                    ></p>
                  ) : item.data.egDocumentDto.actTitleBM ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: item.data.egDocumentDto.actTitleBM,
                      }}
                    ></p>
                  ) : null}
                </div>
              ) : item.type === "caseLaw" ? (
                // Render Case Law Entry UI
                <div className="articles-text">
                  <h3>Case No: {item.data.caseNo}</h3>
                  <p>Case Title: {item.data.caseTitle}</p>
                </div>
              ) : null}
            </div>
          ))}
        </Slider>
      </div>
      <div className="homepage-latest-entries">
        <p>Articles & News</p>
        <p style={{ fontSize: "14px" }}>
          Articles & News are sourced from external providers. PNMB assumes no liability for the accuracy, completeness, or reliability of the content. Users are advised to consult the original sources for further information.
        </p>
      </div>
      <div className="homepage-slider" id="slider2">
        <Slider {...settings2}>
          {articles.map((article, index) => (
            <div key={index} className="homepage-articles-items">
              <div className="articles-text">
                <p>{new Date(article.pubDate).toLocaleDateString()}</p>
                <p>{article.title}</p>

                <p
                  dangerouslySetInnerHTML={{ __html: article.contentSnippet }}
                />
                <p>
                  <a
                    href={article.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="about-us-container" id="about-us">
        <div className="about-us-content">
          <div className="about-us-title">About Us</div>
          <div className="about-us-subtitle">
            The journey of your authoritative legal research begins with one click
          </div>
          <div className="about-us-desc">
            A comprehensive and user-friendly online platform, 
            we serve government and administrative offices and 
            departments, lawyers, legal advisors, academicians, students, 
            and anyone with regular needs to refer to Malaysian laws.
          </div>
          <div className="about-us-subtitle">
            Easy access to a continuously expanding database of Malaysian Laws
          </div>
          <div className="about-us-desc">
            Lawnet Malaysia, established in 1998 under Percetakan Nasional Malaysia Berhad (PNMB), 
            provides an authoritative online library of Malaysian laws. Designed for legal professionals, 
            government officers, and researchers, Lawnet offers convenient and unlimited 
            access to a comprehensive legal database. The latest version, Lawnet 3.0, 
            features AI-assisted search. Additionally, our newly revamped Lawnet mobile app provides 
            users with improved accessibility and a smoother on-the-go access to legal resources. 
            We aim to deliver smarter, faster and more efficient legal research experience—anytime, anywhere.
          </div>
        </div>
      </div>
      <div className="lawnet-features-container" id="features">
        <div className="lawnet-features">
          <div className="lawnet-features-title">Lawnet's Features</div>
          <div className="lawnet-features-content">
            {lawnetFeatures.map((feature, index) => (
              <div key={index} className="lawnet-feature">
                <div className="feature-image">
                  <img src={feature.image} alt={feature.title} />
                </div>{" "}
                <div className="feature-text">
                  <div className="feature-title">{feature.title}</div>
                  <div className="feature-content">{feature.content}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="subscription-container" id="subscription">
        <div className="subscription-title">Subscription</div>
        <div className="subscription-content">
          <div className="subsciption-desc">
            <div className="desc-1">Choose your preferred plan</div>
            <div className="desc-2">
              We offer two different packages depending on your needs and suitability.
            </div>
            <div className="desc-3">
              Contact us for more details <br /> Call : 03 9236 6085/6917 <br />
              Email : lawnet@printnasional.com.my
            </div>
          </div>
          <div className="subscription-option-1">
            <div className="card">

              <div className="card-content">
                <div className="card-title-1">
                  <h2>PACKAGE A</h2>
                  <p style={{ color: "white", fontSize: "18px" }}>
                    <span
                      style={{
                        position: "relative",
                        marginRight: "8px",
                        display: "inline-block",
                        fontSize: "14px",
                      }}
                    >
                      RM2,160
                    </span>
                  </p>
                </div>

                <ul>
                  <li>
                    <p>Acts</p>
                  </li>
                  <li>
                    <p>Orders, Rules and Regulations</p>
                  </li>
                  <li>
                    <p>Federal Constitution</p>
                  </li>
                  <li>
                    <p>Codes, Procedures, Perintah-Perintah Am</p>
                  </li>
                  <li>
                    <p>Federal Gazettes and Bills</p>
                  </li>
                  <li>
                    <p>
                      <b>States Gazettes, Enactment, Ordinances, Bills</b>
                    </p>
                  </li>
                  <li>
                    <p>Case Law</p>
                  </li>
                  <li>
                    <p>Trademark, Patents, Industrial Design</p>
                  </li>
                  <li>
                    <p>HDA, UMA</p>
                  </li>
                  <li>
                    <p>Istilah, Latin Dictionary</p>
                  </li>
                </ul>
              </div>
              <button className="subscribe-button-1" onClick={() => {
                navigate("/register");
              }}>
                <FaRegCheckCircle /> Subscribe Now
              </button>
            </div>
          </div>

          <div className="subscription-option-2">
            <div className="card">

              <div className="card-content">
                <div className="card-title-2">
                  <h2>PACKAGE B</h2>
                  <p style={{ color: "white", fontSize: "18px" }}>
                    <span
                      style={{
                        position: "relative",
                        marginRight: "8px",
                        display: "inline-block",
                        fontSize: "14px",
                      }}
                    >
                      RM1,836
                      
                    </span>
                  </p>
                </div>

                <ul>
                  <li>
                    <p>Acts</p>
                  </li>
                  <li>
                    <p>Orders, Rules and Regulations</p>
                  </li>
                  <li>
                    <p>Federal Constitution</p>
                  </li>
                  <li>
                    <p>Codes, Procedures, Perintah-Perintah Am</p>
                  </li>
                  <li>
                    <p>Federal Gazettes and Bills</p>
                  </li>
                  <li>
                    <p>Case Law</p>
                  </li>
                  <li>
                    <p>Trademark, Patents, Industrial Design</p>
                  </li>
                  <li>
                    <p>HDA, UMA</p>
                  </li>
                  <li>
                    <p>Istilah, Latin Dictionary</p>
                  </li>
                </ul>
              </div>
              <button className="subscribe-button-2" onClick={() => {
                navigate("/register");
              }}>
                <FaRegCheckCircle /> Subscribe Now
              </button>
            </div>
          </div>
        </div>
        <div className="subsciption-sst">
          <p>
            <em>*price inclusive of 8% SST</em>
          </p>
        </div>
      </div>
      <div className="homepage-privacy-container">
        <div className="homepage-privacy-content">
          <div className="privacy-heading">
            Protecting your data is our top priority. 
          </div>
          <div className="privacy-content">
            Read our Privacy Policy to understand how we safeguard your information.
          </div>
          <div className="privacy-button">
            <IoIosArrowDropright
              style={{ fontSize: "1.2rem", fontWeight: "800" }}
              onClickCapture={() => {
                navigate("/privacy-policy");
              }}
            />{" "}
            SHOW MORE
          </div>
        </div>
      </div>
      <div className="homepage-contact-container">
        <div className="homepage-contact-content">
          <div className="homepage-contact">
            <div className="contact-title">QUICK LINKS</div>
            <div className="quicklinks-list">
              <ul>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={() => scrollToSection("about-us")}
                >
                  About Us
                </li>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={() => scrollToSection("features")}
                >
                  Features
                </li>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={() => scrollToSection("subscription")}
                >
                  Subscription
                </li>
                <li style={{ cursor: "pointer" }} onClick={goToPrivacyPolicy}>
                  Privacy Policy
                </li>
                <li style={{ cursor: "pointer" }} onClick={() => setOpenDialog(true)}>Feedback</li>
                <li onClick={handleLogin}>Login</li>
              </ul>
            </div>
          </div>
          <div className="homepage-platform">
            <div className="contact-title">CONNECT WITH US</div>
            <div className="platform-desc">
              Follow us on social media to stay<br />
              informed. Be the first to know about <br />
              the latest updates and developments.
            </div>
            <div className="platform-icon">
              <div className="homepage-socialmedia">
                <div
                  className="icon-container"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleSocial("https://www.linkedin.com/company/lawnetmalaysia")
                  }
                >
                  <FaLinkedin />
                </div>
                <div
                  className="icon-container"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleSocial("https://www.facebook.com/PNMBLawnet")
                  }
                >
                  <FaFacebookF />
                </div>
                <div
                  className="icon-container"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleSocial("https://www.instagram.com/pnmblawnet/")
                  }
                >
                  <FaInstagram />
                </div>
                <div
                  className="icon-container"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleSocial("https://www.youtube.com/@pnmb_official/")
                  }
                >
                  <FaYoutube />
                </div>
              </div>
            </div>
          </div>
          <div className="homepage-address">
            <div className="contact-title">CONTACT US</div>
            <div className="address">
              Unit Lawnet <br />
              Percetakan Nasional Malaysia Berhad (PNMB)<br/>
              199201022436 (253940-X)<br />
              Jalan Chan Sow Lin <br />
              50554 Kuala Lumpur
            </div>
            <div className="contact-info">
              03 9236 6085/6917 <br />
              lawnet@printnasional.com.my
            </div>
          </div>
        </div>
        <div className="homepage-footer">
          Copyright 2025. <p>Percetakan Nasional Malaysia Berhad.</p> All rights
          reserved.
        </div>
      </div>
      
      <FeedbackDialog openDialog={openDialog} setOpenDialog={setOpenDialog} showEmail={true} />
    </div>
  );
}
